import React, { useState } from 'react'

import CreateContainer from './CreateContainer'
import CreateCluster from './CreateCluster'

const tabs = [{ key: 'container', name: 'Ny Container' }, { key: 'cluster', name: 'Nytt Kluster' }]

const CreateLock = () => {
  const [activeTab, setActiveTab] = useState('container')

  return (
    <div>
      <div className="flex">
        {tabs.map((tab) => (
          <button onClick={() => setActiveTab(tab.key)} style={{ padding: '10px 60px', color: activeTab === tab.key ? '#FFF' : '#000F', background: activeTab === tab.key ? '#006e78' : '#FFF' }} key={tab.key}>
            {tab.name}
          </button>
        ))}
      </div>
      {activeTab === 'container' ? <CreateContainer /> : <CreateCluster />}
    </div>
  )
}

export default CreateLock
